import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment, { Moment } from 'moment';
import { synchronizationFailureKey } from 'src/app/helpers/trademark-synchronization.helper';
import {
  CandidateChecks,
  SynchronizationCandidate,
  Trademark,
  TrademarkSynchronizationFailure,
} from 'src/app/models/trademark';

export interface SynchronizeTrademarkCandidatesDialogData {
  candidates: SynchronizationCandidate[];
  // Why the bulk synchronisation would take none of them
  failure?: TrademarkSynchronizationFailure;
  source: Trademark;
}

type CheckState = 'SAME' | 'DIFFERENT' | 'UNKNOWN';

const CHECKS: { key: keyof CandidateChecks, label: string }[] = [
  { key: 'sameTerritory', label: 'SYNC.CANDIDATES.TERRITORY' },
  { key: 'sameNumber', label: 'SYNC.CANDIDATES.NUMBER' },
  { key: 'sameApplicationDate', label: 'SYNC.CANDIDATES.APPLICATION_DATE' },
  { key: 'sameName', label: 'SYNC.CANDIDATES.NAME' },
  { key: 'sharedClass', label: 'SYNC.CANDIDATES.CLASSES' },
];

@Component({
  selector: 'app-synchronize-trademark-candidates-dialog',
  templateUrl: './synchronize-trademark-candidates-dialog.component.html',
  styleUrl: './synchronize-trademark-candidates-dialog.component.scss'
})
export class SynchronizeTrademarkCandidatesDialogComponent implements OnInit {
  readonly checks = CHECKS;
  candidates: SynchronizationCandidate[] = [];
  selected?: SynchronizationCandidate;
  hasMatch: boolean = false;
  failureKey?: string;
  sourceParams: { name: string, identifierNumber: string } = { name: '', identifierNumber: '' };

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: SynchronizeTrademarkCandidatesDialogData,
    private readonly dialogRef: MatDialogRef<SynchronizeTrademarkCandidatesDialogComponent>
  ) {
  }

  ngOnInit(): void {
    this.candidates = this.data.candidates ?? [];
    this.selected = this.candidates.find((candidate) => candidate.match);
    this.hasMatch = !!this.selected;
    this.failureKey = this.data.failure ? synchronizationFailureKey(this.data.failure) : undefined;
    this.sourceParams = {
      name: this.data.source?.name || this.data.source?.identifierNumber || '',
      identifierNumber: this.data.source?.identifierNumber ?? ''
    };
  }

  checkState(candidate: SynchronizationCandidate, key: keyof CandidateChecks): CheckState {
    const value = candidate.checks?.[key];
    if (value === true) return 'SAME';
    if (value === false) return 'DIFFERENT';
    return 'UNKNOWN';
  }

  classNumbers(candidate: SynchronizationCandidate): number[] {
    return (candidate.niceClassification ?? []).map((niceClass) => Number(niceClass.classNumber));
  }

  formatDate(date?: Moment) {
    return date ? moment(date).format('LL') : '-';
  }

  select(candidate: SynchronizationCandidate) {
    this.selected = candidate;
  }

  public onConfirm() {
    this.dialogRef.close({
      selected: true,
      trademark: this.selected
    })
  }

  public onCancel() {
    this.dialogRef.close({
      selected: false
    });
  }

}
